/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Options, UnwrappedResult } from '../../.kubb/client'
import type { GetCourseDocumentTokenOptions, GetCourseDocumentTokenResponses } from '../../models/GetCourseDocumentToken'
import { client, unwrapResult } from '../../.kubb/client'

/**
 * @description Get a document download token. This token is used to download document contents from the download-document route.
 * @summary Get Course Document Download Token
 * {@link /course/:course_id/document/:document_id/token}
 */
export function getCourseDocumentToken<ThrowOnError extends boolean = true>(options: Options<GetCourseDocumentTokenOptions, ThrowOnError>): Promise<UnwrappedResult<GetCourseDocumentTokenResponses, ThrowOnError>> {
  const { client: request = client, ...config } = options

  return unwrapResult(request({ method: 'GET', url: '/course/{course_id}/document/{document_id}/token', security: [{ type: 'oauth2' }], ...config, throwOnError: config.throwOnError ?? true }), config.throwOnError ?? true) as Promise<UnwrappedResult<GetCourseDocumentTokenResponses, ThrowOnError>>
}
